import { FunctionComponent } from 'react';
import styles from './OnboardingCard.module.scss';

export type OnboardingCardProps = {
  title?: string;
  titleSize?: 'sm' | 'md';
  cardInfo?: React.JSX.Element;
  content: React.JSX.Element;
  padding?: string;
  hasNoRightPadding?: boolean;
};

type FC = FunctionComponent<OnboardingCardProps>;

const OnboardingCard: FC = (props) => {
  const { title, titleSize = 'md', cardInfo, content, padding = '36px', hasNoRightPadding } = props;

  return (
    <div style={hasNoRightPadding ? { padding, paddingRight: 0 } : { padding }} className={styles.OnboardingCard}>
      {title !== '' && (
        <div className={styles.titleContainer}>
          <h2 className={styles[`title-${titleSize}`]}>{title}</h2>
          {cardInfo && <div>{cardInfo}</div>}
        </div>
      )}
      <div className={styles.contentContainer}>{content}</div>
    </div>
  );
};

export default OnboardingCard;
